import React from 'react';
import additionalInsight from '../img/analyticssvg.svg'

const AdditionalInsight = () => (
  <img src={additionalInsight} alt="Insights" />
);

export default AdditionalInsight;